<div class="mt-2 preview-wrapper" [class.full]="heightMode == 'FULL'">

  <img [src]="dataUrl" *ngIf="previewType == 'IMAGE'" />

  <!--<embed [src]="dataUrl" *ngIf="previewType == 'EMBED'" />-->

  <iframe [src]="dataUrl" *ngIf="previewType == 'EMBED'" width="100%" [style.height]="'400px'" frameborder="0"></iframe>


  <iframe [src]="dataUrl" *ngIf="previewType == 'OFFICE'"  width="100%" [style.height]="'400px'"></iframe>
  
  <div *ngIf="previewType == 'GENERIC'" class="text-center">

    <div class="pt-20 generic-preview">
      <mat-icon [svgIcon]="'heroicons_solid:document'" class="big-icon"></mat-icon>
    </div>
    <i>{{'modal.file.noPreview' | transloco}}</i>
  </div>

  <div *ngIf="previewType == 'EXTERNAL'" class="text-center">

    <div class="pt-20 generic-preview">
      <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'" class="big-icon"></mat-icon>
    </div>

   <a [href]="dataUrl" target="_blank"><i>[EXTERNAL URL]</i></a>
  </div>
</div>